import { QuickInterviewActions } from './actions'
import { QuickInterviewGetters } from './getters'
import { QuickInterviewMutations } from './mutations'
import { QuickInterviewState } from './state'

export const QUICK_INTERVIEW_NAMESPACE = 'quickInterview'

export const QuickInterview = {
  namespaced: true,
  state: QuickInterviewState,
  actions: QuickInterviewActions,
  mutations: QuickInterviewMutations,
  getters: QuickInterviewGetters,
}
